import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 128 131"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M69.85 3.406c1.834-3.714 7.13-3.714 8.965 0l19.074 38.602a5 5 0 0 0 3.76 2.733l42.655 6.228c4.102.599 5.735 5.64 2.765 8.53l-30.85 30.017a5 5 0 0 0-1.442 4.43l7.281 42.405c.701 4.084-3.585 7.199-7.253 5.272l-38.148-20.04a5 5 0 0 0-4.65 0l-38.148 20.04c-3.668 1.927-7.954-1.188-7.253-5.272l7.28-42.405a5 5 0 0 0-1.44-4.43L1.596 59.5c-2.971-2.89-1.338-7.932 2.764-8.531l42.655-6.228a5 5 0 0 0 3.76-2.733z"
    }, null, -1)
  ])))
}
export default { render: render }